import React from "react";
import "./check.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Check = ({signupUrl}) => {
  const navigate = useNavigate();

  const handleSignupClick = () => {
    if(signupUrl === '/business') {
      // Business page - redirect to Shopify App Store
      window.location.href = "https://apps.shopify.com/purebrand?search_id=5c43b5ca-bc55-46f1-b480-117255639a1b&surface_detail=Purebrand&surface_inter_position=1&surface_intra_position=1&surface_type=search";
    } else {
      // All other pages - go to regular signup
      navigate("/signup");
    }
  };

  const handleLoginClick = () => {
    if(signupUrl === '/business') {
      // Business page - redirect to Shopify App Store for login/signup
      window.location.href = "https://apps.shopify.com/purebrand?search_id=5c43b5ca-bc55-46f1-b480-117255639a1b&surface_detail=Purebrand&surface_inter_position=1&surface_intra_position=1&surface_type=search";
    } else {
      // All other pages - go to regular login
      navigate("/login");
    }
  };

  return (
    <div className="auth-buttons">
    <Button
      onClick={handleSignupClick}
      className="header-signup"
      style={{ backgroundColor: "#9194E7" }}
    >
      Sign up
    </Button>
    <Button
      onClick={handleLoginClick}
      className="header-login"
      style={{
        border: "#9194E7 solid 1px",
        color: "#9194E7",
        backgroundColor: "white",
      }}
    >
      Log in
    </Button>
  </div>
  
  );
};

export default Check;
